<template>
  <div class="root" v-if="rux.length !== 0">
    <GeoLocation v-if="$route.query.fromScan" />
    <VueConfirmDialog :parent="_uid" />
    <div class="details container">
      <section>
        <div class="row push-down-20">
          <div class="col-12 grid">
            <div class="row no-border">
              <div class="col-12 no-padding short-header">
                <EditableInput @save="updatedInput('shortDescription', ...arguments)" v-model="rux.shortDescription"
                  placeholder="Add a name..." class="editable-input-name"></EditableInput>
              </div>
            </div>
          </div>
          <div class="col-12 grid">
            <div class="row">
              <div class="col-12 no-padding head">
                <EditableInput @save="updatedInput('fullDescription', ...arguments)" v-model="rux.fullDescription"
                  :textarea="false" placeholder="Add a description..." class="editable-input-description" />
              </div>
            </div>
          </div>

          <div class="col-12 packing-list-wrapper">
            <PackingList @add="addPackingListItem" @delete="deletePackingListItem" @update="updatePackingListItem" @deleteAll="deleteAllPackingListItems"
              :items="rux.packingListItems" :showTitle="true" :fullWidth="true" :showSelect="true" />
            <!-- for future logic integration -->
            <!-- <button @click ="mergePackingListItems(packingList.items)" class="packing-btn push-down-10">save as packing list</button> -->
          </div>

          <div class="col-12 packing-list-wrapper assign-packing">
            <div class="col-12 head-assign">ASSIGN PACKING LIST</div>
            <select @change="onPackingListSelected($event)" class="col-12" v-model="packingList" name="packingList"
              id="packingList">
              <option value="" disabled selected>SELECT A PACKING LIST</option>
              <option :key="index" v-for="(item, index) in list" :value="item"> {{ item.name }}</option>
            </select>
            <PackingList v-if="(showAssignButton && packingList.packingListItems.length > 0)" @update="updateItem"
              :items="packingList.packingListItems" :showTitle="false" :showTitlePackingList="false" :readOnly="true"
              :fullWidth="true" :showSelect="true" />
            <div v-else-if="showEmptyList" class="push-down-20">THIS PACKING LIST HAS NO ITEMS, SELECT ANOTHER LIST OR
              <router-link :to="{ name: 'PackingList' }">EDIT THIS LIST
              </router-link>
            </div>
            <div v-if="showNoItems">
              NO ITEMS SELECTED, PLEASE SELECT AN ITEM TO ADD
            </div>
            <div v-if="!showEmptyList && !showNoItems && showAssignButton">
              SELECT ITEMS YOU'D LIKE TO ADD FROM THE PACKING LIST TO YOUR RUX
            </div>
            <button v-if="showAssignButton" class="packing-btn pointer push-down-10"
              @click="mergePackingListItems(packingList)">ASSIGN</button>
          </div>
          <!-- <button @click="updatePackingListItem(item)">Submit</button> -->
          <div class="col-12 packing-list-wrapper">
            <RuxDetailsImages @addImage="addImage" @deleteImage="deleteImage" :currentRuxImages="currentRuxImages" />
          </div>

          <div class="col-12 grid border-bottom push-down-10">
            <div class="row">
              <div class="col-12 col-sm-6 head">LAST SAVED LOCATION:</div>
              <div class="col-12 col-sm-6">
                <div class="link pointer" v-if="rux.friendlyLocation" @click="showMap = !showMap"
                  data-testid="google-map">
                  <span v-if="!showMap">Open</span><span v-else>Close</span> Map
                </div>
                <span v-else>No saved Geo-Locations available</span>
              </div>
            </div>
            <div v-if="rux.friendlyLocation && showMap" class="row">
              <div class="col-12">
                <GoogleMap class="push-down-20" :lat="rux.location.latitude" :long="rux.location.longitude" :zoom="10"
                  :title="rux.shortDescription" :content="rux.manualLocation" />
              </div>
            </div>
          </div>

          <div class="col-12 grid border-bottom">
            <div class="row">
              <div class="col-12 col-sm-6 head">
                LOCATION INFO:
              </div>
              <div class="col-12 col-sm-6 no-padding roman">
                <EditableInput @save="updatedInput('manualLocation', ...arguments)" v-model="rux.manualLocation"
                  placeholder="Add specific location info..." />
              </div>
            </div>
          </div>
          <div class="col-12 grid border-bottom">
            <div class="row">
              <div class="col-12 col-sm-6 head">
                SERIAL NUMBER:
              </div>
              <div class="col-12 col-sm-6 roman flex-container">
                {{ rux.serialNumber }}
                <div @click="deleteRux(rux.serialNumber)" class=" material-symbols-outlined deleteRux pointer">
                  delete_forever
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 grid border-bottom">
            <div class="row">
              <div class="col-12 col-sm-6 head">
                REGISTERED ON:
              </div>
              <div class="col-12 col-sm-6 roman">
                {{ rux.friendlyDateRegisteredOn }}
              </div>
            </div>
          </div>
          <div class="col-12 grid border-bottom">
            <div class="row">
              <div class="col-12 col-sm-6 head">
                LAST UPDATE:
              </div>
              <div class="col-12 col-sm-6 roman">
                {{ rux.friendlyLastUpdatedOn }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EditableInput from './EditableInput'
import GoogleMap from './GoogleMap'
import PackingList from './PackingList'
import RuxDetailsImages from './RuxDetailsImages'
import GeoLocation from './GeoLocation'
import VueConfirmDialog from './ConfirmDialog/vue-confirm-dialog'
// A component used to display the details of a RUX.
// It watches to see if the route changes to get the details of whatever RUX is loaded
export default {
  name: 'RuxDetails',
  components: {
    EditableInput,
    PackingList,
    RuxDetailsImages,
    GoogleMap,
    GeoLocation,
    VueConfirmDialog,
  },
  data: () => {
    return {
      showMap: false,
      finishedLoading: false,
      packingList: "",
      showAssignButton: false,
      showNoItems: false,
      showEmptyList: false,
    }
  },
  // This watches the route. When it changes it loads the new rux
  watch: {
    // Because Geolcation is set in another component, watch the store value here to make sure it is set before trying to update the value
    geolocatioWatcher(to, from) {
      if (this.$route.query.fromScan && to === true) {
        this.updateRuxFromScan()
      }
    },
  },
  computed: {
    ...mapState({
      currentRux: (state) => state.rux.currentRux,
      geolocation: (state) => state.rux.geolocation,
      currentRuxImages: (state) => state.rux.currentRuxImages,
      list: (state) =>
        state.packingListTemplate.list.map((template) => {
          return {
            ...template,
            shortDescription: template.name,
            images: template.images.slice(0, 2)
          }
        }),
    }),
    rux: function () {
      // Get the current rux from the store
      return this.currentRux || {}
    },
    // Watch the geolocation property in the store. This stops the race condition of the mounted calls in Geolocation
    // being beaten by having the updateRux set in mounted.
    geolocatioWatcher: function () {
      return this.geolocation.isSet || {}
    },
  },
  methods: {
    // Get the rux from the store
    async getRux(serialNumber) {
      this.$store.dispatch('rux/getRux', serialNumber)
    },
    // Get the images from the the db and add them to the store. this.images watches for this change
    async getImages(serialNumber) {
      this.$store.dispatch('rux/getImages', serialNumber)
    },
    // Called when one of the editable inputs is saved.
    updatedInput(prop, val) {
      // Update the correct property with the value here
      this.rux[prop] = val
      // Dispatch to the store to update.
      this.$store.dispatch('rux/updateRux', this.rux)
    },
    updateRuxFromScan() {
      this.rux.serialNumber = this.$route.params.serialNumber
      this.rux.updateLocation = true
      this.$store.dispatch('rux/updateRux', this.rux)
    },
    // Add the packing list from the child component
    async addPackingListItem(item) {
      await this.$store.dispatch('rux/addPackingListItem', {
        item,
        serialNumber: this.$route.params.serialNumber,
      })
    },
    // Let the store handle the delete from the db and the UI.
    // Pass the item and SerialNumber so Firebase can find it, pass the index so Vue can find it.
    deletePackingListItem(params) {
      const { item, index } = params
      this.$store.dispatch('rux/deletePackingListItem', {
        item,
        index,
        serialNumber: this.$route.params.serialNumber,
      })
    },
    deleteAllPackingListItems() {
      this.$store.dispatch('rux/deleteAllPackingListItems', this.$route.params.serialNumber)
    },
    updatePackingListItem(params) {
      this.$store.dispatch('rux/updatePackingListItem', params)
    },
    mergePackingListItems(params) {
      if (params.packingListItems.length > 0) {
        params.packingListItems.forEach(element => {
          if (element.checked) {
            this.addPackingListItem(element.value)
          }
          else if (!element.checked) {
            this.showNoItems = false
          }
        })
      } else {
        this.showAssignButton = false
      }
    },
    updateItem(params) {
      const { index, value } = params
      this.packingList.packingListItems[index].checked = value
    },
    onPackingListSelected(e) {
      if (this.packingList.packingListItems.length > 0) {
        this.showAssignButton = true
        this.showEmptyList = false
        this.showNoItems = false
      } else {
        this.showEmptyList = true
        this.showAssignButton = false
      }
    },
    deleteRux(serialNumber) {
      this.$confirm({
        message: 'Really remove this RUX from your account? This cannot be undone',
        buttons: [
          {
            text: 'Cancel',
          },
          {
            text: 'Remove',
            callback: () => {
              this.$store.dispatch('rux/deleteRuxFromAccount', { serialNumber: serialNumber, route: '/' })
            },
          },
        ],
        parent: this._uid,
      })
    },
    async addImage(params) {
      const { imageData, callback } = params
      await this.$store.dispatch('rux/uploadImage', imageData)
      if (callback) callback()
    },
    async deleteImage(params) {
      const _params = {
        ...params,
        serialNumber: this.$route.params.serialNumber,
      }
      await this.$store.dispatch('rux/deleteImage', _params)
    },
  },
  async mounted() {
    // Get the rux from the store
    await this.getRux(this.$route.params.serialNumber)
    await this.getImages(this.$route.params.serialNumber)
    await this.$store.dispatch('packingListTemplate/getAllPackingListTemplates')
    if (this.$route.query.fromScan && this.geolocation.isSet) {
      this.updateRuxFromScan()
    }
  },
  async destroyed() {
    // This clears the images and packing list items so that they don't appear after navigation
    await this.$store.dispatch('rux/clearCurrentRUX')
  },
}
</script>

<style lang='scss' scoped>
.editable-input-name {
  font-size: large;
  font-family: "Neue Medium";
}
.editable-input-description {
  font-size: large;
  font-family: "Neue Roman";
  font-weight: 100;
}
.border-top {
  margin-top: 40px;
  padding-top: 40px;
}
.packing-btn {
  background-color: $ruxGreen;
  height: 35px;
  font-size: small;
}
.roman {
  font-family: "Neue Roman";
  text-transform: uppercase;
}
.geolocation-error {
  color: white;
  padding: 8px;
  background-color: $ruxRed;
}
.delete {
  color: $ruxRed;
}
.link {
  color: $ruxGreen;
  text-decoration: underline;
}
.packing-list-wrapper {
  width: 90%;
  margin: 20px auto;
  padding: 16px;
  background-color: white;
  border-radius: 0px;
  border: 1px solid black;
  box-shadow: 0 2px 2px rgb(0 0 0 / 11%), 0 1px 1px rgb(0 0 0 / 18%);
  @include respond-to('sm') {
    width: 66%;
    padding: 16px;
    padding: 40px;
  }
}
.head-assign {
  font-size: large;
  font-weight: bold;
  text-align: left;
  padding-left: 0px;
  padding-bottom: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
  @include respond-to('sm') {
    font-weight: normal;
    padding-bottom: 0px;
  }
}
select#packingList {
  height: 40px;
}
select#packingList:focus-visible {
  outline: none;
}
.details {
  padding: 0px 30px;
  margin: 0 auto;
  margin-top: 40px;
  .loader-wrapper {
    position: relative;
    height: 40px;
  }
  div.row {
    align-items: center;
    justify-content: center;
    div.grid {
      padding: 4px;
      text-align: left;
      @include respond-to('sm') {
        text-align: left;
        padding: 16px 0px;
        margin: 0px;
        border: none;
      }
      .no-padding {
        padding-left: 0px;
        padding-right: 0px;
        @include respond-to('sm') {
          padding-left: 15px;
          padding-right: 15px;
        }
      }
      .short-header {
        font-size: 2rem;
        font-weight: 200;
        overflow: hidden;
        font-family: "Neue Roman";
        white-space: nowrap;
      }
      .head {
        font-weight: bold;
        padding-bottom: 8px;
        @include respond-to('sm') {
          font-weight: normal;
          padding-bottom: 0px;
        }
      }
      .add-margin-top {
        margin-top: 20px;
        @include respond-to('sm') {
          margin-top: 0px;
        }
      }
    }
  }
  .border-bottom {
    border-bottom: solid 0.5px darkgray;
    margin-bottom: 10px;
    font-size: large;
  }
  .deleteRux {
    font-size: 1.5rem;
    color: black;
    position: relative;
    padding-right: 5px;
   }
  .flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  }
}
</style>